import HttpClient from 'server/helpers/HttpClient';
import { getWeakTicket } from 'shared/clientUtils';
import { insightSelectors } from 'store/insight/selectors';
import { saleSelectors } from 'store/sale/selectors';
import { RootState } from 'store/store';

const httpClient = HttpClient.getInstance();

export const createAffirmBnplOrder = async (state: RootState) => {
  const { payment, auth, insight, sale, config } = state as any;

  const domainId = insightSelectors.domainId(insight);
  const token = insightSelectors.tokenSelector(insight);
  const currency = saleSelectors.currencySelector(sale);
  const profileToken = insightSelectors.riskProfileTokenSelector(insight);

  const { amount, contactDetailsEmail, contactDetailsName } = payment;
  const { entityId, realmId, ticket, isUserSignedIn, syncToken, authToken, recipientEmail } =
    auth || ({} as any);
  const { ssrtid, portal } = (config || {}) as any;

  const type = saleSelectors.typeSelector(sale);
  const subType = sale?.subType;
  const customerName = sale?.contact?.displayName;
  const toEmails = sale?.contact?.toEmails;

  const headers = getWeakTicket({
    domainId,
    entityId,
    realmId,
    token,
    ticket,
    isUserSignedIn,
    syncToken,
    authToken,
    ssrtid,
  });

  const payorEmail = recipientEmail || contactDetailsEmail || (toEmails && toEmails[0]) || '';

  const data: any = {
    payment: {
      method: 'AFFIRM_BNPL',
      amount: Number(amount).toFixed(2),
      currencyCode: currency,
    },
    risk: { profileToken },
    sale: {
      type,
      isGpu: saleSelectors.isGpu(sale),
      subType,
    },
    contact: {
      name: contactDetailsName || customerName,
      emails: payorEmail ? [payorEmail] : [],
    },
  };

  const result = await httpClient({
    url: `/${portal}/rest/affirm-bnpl/create-order`,
    endpoint: `/${portal}/rest/affirm-bnpl/create-order`,
    method: 'POST',
    data,
    headers,
    timeout: 100000,
  });

  return result;
};

export const confirmAffirmBnplOrder = async (
  state: RootState,
  checkoutId: string,
  email?: string
) => {
  if (!checkoutId) return;
  const { payment, auth, insight, sale, config } = state as any;

  const domainId = insightSelectors.domainId(insight);
  const token = insightSelectors.tokenSelector(insight);
  const currency = saleSelectors.currencySelector(sale);
  const profileToken = insightSelectors.riskProfileTokenSelector(insight);

  const { amount, contactDetailsEmail, contactDetailsName } = payment;
  const { entityId, realmId, ticket, isUserSignedIn, syncToken, authToken, recipientEmail } =
    auth || ({} as any);
  const { ssrtid, portal } = (config || {}) as any;
  const type = saleSelectors.typeSelector(sale);
  const subType = sale?.subType;
  const customerName = sale?.contact?.displayName;
  const toEmails = sale?.contact?.toEmails;

  const headers = getWeakTicket({
    domainId,
    entityId,
    realmId,
    token,
    ticket,
    isUserSignedIn,
    syncToken,
    authToken,
    ssrtid,
  });

  const resolvedEmail =
    email || recipientEmail || contactDetailsEmail || (toEmails && toEmails[0]) || '';

  const data: any = {
    payment: {
      method: 'AFFIRM_BNPL',
      amount: Number(amount).toFixed(2),
      currencyCode: currency,
    },
    risk: {
      profileToken,
    },
    sale: {
      type,
      isGpu: saleSelectors.isGpu(sale),
      subType,
    },
    contact: {
      name: contactDetailsName || customerName,
      emails: resolvedEmail ? [resolvedEmail] : [],
    },
    affirm: {
      checkoutId,
    },
  };

  const result = await httpClient({
    url: `/${portal}/rest/affirm-bnpl/confirm-order`,
    endpoint: `/${portal}/rest/affirm-bnpl/confirm-order`,
    method: 'POST',
    data,
    headers,
    timeout: 100000,
  });

  return result;
};
